import CheckmateZoneApiClient from '../../services/zoneApiClient';
import { useQuery } from 'react-query';

// Instead of returning useQuery directly:
export const zoneUsersQueryOptions = (
    zoneApiClient: CheckmateZoneApiClient,
    dataScope?: number,
    filterUserRights?: number[]
) => ({
    queryKey: ['get-zone-users', { dataScope, filterUserRights }],
    queryFn: async () => {
        const response = await zoneApiClient.getUsersInZone(dataScope, filterUserRights);

        if (response.httpResponse.status === 401) window.location.reload();
        if (!response.httpResponse.ok) throw new Error('Failed to retrieve zone users.');
        if (response.errorMessage) throw new Error(response.errorMessage);

        return response.payload;
    },
    staleTime: 60_000,
});

// Hook still works standalone
export const useZoneUsers = (
    zoneApiClient: CheckmateZoneApiClient,
    dataScope?: number,
    filterUserRights?: number[]
) => useQuery(zoneUsersQueryOptions(zoneApiClient, dataScope, filterUserRights));
